import React, {Component} from 'react'
import PropTypes from 'prop-types'
import t from 'format-message'
import {Alert} from '@instructure/ui-alerts'
import {View} from '@instructure/ui-view'

export default class Alerts extends Component {
  static propTypes = {
    removeAlert: PropTypes.func.isRequired,
    alerts: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        message: PropTypes.string,
        variant: PropTypes.string,
      }),
    ),
  }

  closeAlert = uuid => () => {
    this.props.removeAlert(uuid)
  }

  liveRegion = () => document.getElementById('alertHolder')

  renderAlert = alert => {
    return (
      <Alert
        key={alert.uuid}
        screenReaderOnly
        liveRegion={this.liveRegion}
        onDismiss={this.closeAlert(alert.uuid)}
        renderCloseButtonLabel={t('Close')}
        transition="none"
      >
        {alert.message}
      </Alert>
    )
  }

  renderVisualAlert = alert => {
    return (
      <Alert
        key={alert.uuid}
        variant={alert.variant}
        onDismiss={this.closeAlert(alert.uuid)}
        renderCloseButtonLabel={t('Close')}
      >
        {alert.message}
      </Alert>
    )
  }

  render() {
    const {alerts} = this.props
    const srAlerts = alerts.filter(a => a.variant === 'screenreader')
    const visualAlerts = alerts.filter(a => a.variant !== 'screenreader')

    return (
      <View as="div">
        <View as="div">{srAlerts.map(this.renderAlert)}</View>
        {visualAlerts.length > 0 && (
          <View
            as="div"
            position="fixed"
            insetBlockStart="1rem"
            insetInlineStart="0"
            insetInlineEnd="0"
            stacking="topmost"
          >
            <View as="div" width="600px" maxWidth="calc(100vw - 2rem)" margin="0 auto">
              {visualAlerts.map(this.renderVisualAlert)}
            </View>
          </View>
        )}
      </View>
    )
  }
}
